import { Container, Skeleton } from '@resolute/ui';

/** Loading placeholder for the property detail page. Block heights mirror the
 *  real layout (gallery, facts card, contact rail) so the page doesn't shift
 *  when the data lands. */
export function DetailSkeleton() {
  return (
    <Container className="py-10">
      <Skeleton className="mb-4 h-4 w-64" />
      <Skeleton className="mb-6 h-10 w-2/3" />
      <div className="grid gap-8 lg:grid-cols-[1fr_360px]">
        <div className="flex flex-col gap-6">
          <Skeleton className="h-[420px] w-full sm:h-[480px] lg:h-[520px]" />
          <Skeleton className="h-32 w-full" />
          <Skeleton className="h-40 w-full" />
        </div>
        <Skeleton className="h-80 w-full" />
      </div>
    </Container>
  );
}
